import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Construction } from "lucide-react";
import { Layout } from "@/components/Layout";

const ClientProfileRegistration = () => {
  return (
    <Layout title="Cadastro de Clientes">
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="w-full max-w-md text-center border-orange-200 bg-orange-50/30">
          <CardHeader>
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="p-3 rounded-full bg-primary/10">
                <Users className="h-8 w-8 text-primary" />
              </div>
              <Construction className="h-6 w-6 text-orange-500" />
            </div>
            <CardTitle className="text-2xl">Cadastro de Clientes</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Esta página está em desenvolvimento.
              <br />
              Em breve você poderá cadastrar e gerenciar clientes aqui.
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default ClientProfileRegistration;